import React from 'react';
import style from "../Perfil.module.css";


const ProfileNotificationsSection = () => {

  return (
    <>
      <h3 className={`mb-4 ${style.sectionTitle}`}>Notificaciones</h3>
    </>
  )
}

export default ProfileNotificationsSection;